export type TFeatureFlagValue = boolean | readonly string[];

/**
 * Default feature flag values
 * Used as fallback when API fails or during initialization
 */
export const DEFAULT_FEATURE_FLAGS = {
	PRODTVouchersFeatureFlag: false,
	isDriverBookingCodeEnabled: false,
	isNewActivitiesEnabled: false,
	priorityDistributorIds: [] as readonly string[],
} as const;

export type FeatureFlagKey = keyof typeof DEFAULT_FEATURE_FLAGS;
